<template>
  <div class="template-padding">
    <form
      @submit.prevent="editInstructor"
      @reset.prevent="cancelEdit"
    >
      <div class="row">
        <div class="div col col-sm-6">
          <h4 class="font-weight-bolder">
            INSTRUCTOR DETAILS
          </h4>
        </div>

        <div class="col col-sm-6 text-right">
          <button
            type="submit"
            class="btn btn-sm btn-warning font-weight-bolder mr-3"
          >
            <span><i class="fas fa-edit" /></span>
            {{ instructorEditable ? 'UPDATE':'EDIT' }}
          </button>
          <button
            type="reset"
            class="btn btn-sm btn-outline-secondary font-weight-bolder"
            v-if="instructorEditable"
          >
            <!--                            @click="toggleInstructorEditable"-->
            <span>
              <i class="fas fa-ban" />
            </span>
            CANCEL
          </button>
          <button
            v-else
            class="btn btn-sm btn-outline-secondary font-weight-bolder"
            @click="goBack"
          >
            <span>
              <i class="fas fa-backward" />
            </span>GO BACK
          </button>
        </div>
      </div>
      <hr class="hr-color">

      <div class="card">
        <div class="card-body row">
          <div class="col col-sm-6">
            <div
              class="form-group form-row"
              :class="{'has-error': errorInstructor.code !== ''}"
            >
              <label
                class="col col-sm-3 col-form-label font-weight-bolder text-right"
                for="code"
              >CODE:</label>
              <div class="col col-sm-9">
                <input
                  type="text"
                  id="code"
                  placeholder="INSTRUCTOR CODE"
                  class="form-control form-control-xs"
                  v-model="instructorData.code"
                  :readonly="!instructorEditable"
                >
                <span
                  class="help-block"
                  v-if="errorInstructor.code !== ''"
                >
                  <small><strong>{{ errorInstructor.code }}</strong></small>
                </span>
              </div>
            </div>

            <div
              class="form-group form-row"
              :class="{'has-error': errorInstructor.last_name !== ''}"
            >
              <label
                class="col col-sm-3 col-form-label font-weight-bolder text-right"
                for="lastName"
              >LAST NAME:</label>
              <div class="col col-sm-9">
                <input
                  type="text"
                  id="lastName"
                  placeholder="INSTRUCTOR LAST NAME"
                  required
                  class="form-control form-control-xs"
                  v-model="instructor.last_name"
                  :readonly="!instructorEditable"
                >
                <span
                  class="help-block"
                  v-if="errorInstructor.last_name !== ''"
                >
                  <small><strong>{{ errorInstructor.last_name }}</strong></small>
                </span>
              </div>
            </div>

            <div
              class="form-group form-row"
              :class="{'has-error': errorInstructor.first_name !== ''}"
            >
              <label
                class="col col-sm-3 col-form-label font-weight-bolder text-right"
                for="firstName"
              >FIRST NAME:</label>
              <div class="col col-sm-9">
                <input
                  type="text"
                  id="firstName"
                  placeholder="INSTRUCTOR FIRST NAME"
                  required
                  class="form-control form-control-xs"
                  v-model="instructorData.first_name"
                  :readonly="!instructorEditable"
                >
                <span
                  class="help-block"
                  v-if="errorInstructor.first_name !== ''"
                >
                  <small><strong>{{ errorInstructor.first_name }}</strong></small>
                </span>
              </div>
            </div>

            <div
              class="form-group form-row"
              :class="{'has-error': errorInstructor.middle_name !== ''}"
            >
              <label
                class="col col-sm-3 col-form-label font-weight-bolder text-right"
                for="lastName"
              >MIDDLE NAME:</label>
              <div class="col col-sm-9">
                <input
                  type="text"
                  id="middleName"
                  placeholder="INSTRUCTOR MIDDLE NAME"
                  class="form-control form-control-xs"
                  v-model="instructorData.middle_name"
                  :readonly="!instructorEditable"
                >
                <span
                  class="help-block"
                  v-if="errorInstructor.middle_name !== ''"
                >
                  <small><strong>{{ errorInstructor.middle_name }}</strong></small>
                </span>
              </div>
            </div>

            <div
              class="form-group form-row"
              :class="{'has-error': errorInstructor.email !== ''}"
            >
              <label
                class="col col-sm-3 col-form-label font-weight-bolder text-right"
                for="email"
              >EMAIL:</label>
              <div class="col col-sm-9">
                <input
                  type="email"
                  id="email"
                  placeholder="INSTRUCTOR EMAIL"
                  class="form-control form-control-xs"
                  :readonly="!instructorEditable"
                  v-model="instructorData.email"
                >
                <span
                  class="help-block"
                  v-if="errorInstructor.email !== ''"
                >
                  <small><strong>{{ errorInstructor.email }}</strong></small>
                </span>
              </div>
            </div>
          </div>

          <div class="col col-sm-6">
            <div
              class="form-group form-row"
              :class="{'has-error': errorInstructor.username !== ''}"
            >
              <label
                class="col col-sm-4 col-form-label font-weight-bolder text-right"
                for="instructor-username"
              >USERNAME:</label>
              <div class="col col-sm-8">
                <input
                  type="text"
                  id="instructor-username"
                  placeholder="INSTRUCTOR USERNAME"
                  required
                  class="form-control form-control-xs"
                  :readonly="!instructorEditable"
                  v-model="instructorData.username"
                >
                <span
                  class="help-block"
                  v-if="errorInstructor.username !== ''"
                >
                  <small><strong>{{ errorInstructor.username }}</strong></small>
                </span>
              </div>
            </div>

            <div
              v-if="instructorEditable"
              class="form-group form-row"
              :class="{'has-error': errorInstructor.password !== ''}"
            >
              <label
                class="col col-sm-4 col-form-label font-weight-bolder text-right"
                for="instructor-password"
              >PASSWORD:</label>
              <div class="col col-sm-8">
                <input
                  type="password"
                  id="instructor-password"
                  placeholder="INSTRUCTOR PASSWORD"
                  autocomplete="false"
                  class="form-control form-control-xs"
                  :readonly="!instructorEditable"
                  v-model="instructorData.password"
                >
                <span
                  class="help-block"
                  v-if="errorInstructor.password !== ''"
                >
                  <small><strong>{{ errorInstructor.password }}</strong></small>
                </span>
              </div>
            </div>

            <div
              v-if="instructorEditable"
              class="form-group form-row"
              :class="{'has-error': errorInstructor.password}"
            >
              <label
                class="col col-sm-4 col-form-label font-weight-bolder text-right"
                for="lastName"
              >CONFIRM PASSWORD:</label>
              <div class="col col-sm-8">
                <input
                  type="password"
                  id="confirmPassword"
                  placeholder="INSTRUCTOR CONFIRM PASSWORD"
                  class="form-control form-control-xs"
                  :readonly="!instructorEditable"
                  v-model="instructorData.confirmPassword"
                >
                <span
                  class="help-block"
                  v-if="!!errorInstructor.password"
                >
                  <small><strong>{{ errorInstructor.password }}</strong></small>
                </span>
              </div>
            </div>

            <div
              class="form-group form-row"
              :class="{'has-error': errorInstructor.training_center_id !== ''}"
            >
              <label
                class="col col-sm-4 col-form-label font-weight-bolder text-right"
                for="trainingCenter"
              >TRAINING CENTER:</label>
              <div class="col col-sm-8">
                <select
                  id="trainingCenter"
                  required
                  class="form-control form-control-xs"
                  v-model="instructorData.training_center_id"
                  :disabled="!instructorEditable"
                >
                  <option :value="null">
                    --- SELECT TRAINING CENTER ---
                  </option>
                  <option
                    v-for="trainingCenter in trainingCenters"
                    :key="trainingCenter.id"
                    :value="trainingCenter.id"
                  >
                    {{ trainingCenter.name }}
                  </option>
                </select>
                <span
                  class="help-block"
                  v-if="errorInstructor.training_center_id !== ''"
                >
                  <small><strong>{{ errorInstructor.training_center_id }}</strong></small>
                </span>
              </div>
            </div>

            <div
              class="form-group form-row"
              :class="{'has-error': errorInstructor.status !== ''}"
            >
              <label
                class="col col-sm-4 col-form-label font-weight-bolder text-right"
                for="status"
              >STATUS:</label>
              <div class="col col-sm-1">
                <input
                  type="checkbox"
                  id="status"
                  class="form-control form-control-xs"
                  v-model="instructor.status"
                  :disabled="!instructorEditable"
                >
              </div>
              <label class="col-sm-3 col-form-label font-weight-bolder">
                {{ instructorData.status ? 'ACTIVE':'INACTIVE' }}
              </label>
              <span
                class="help-block"
                v-if="errorInstructor.status !== ''"
              >
                <small><strong>{{ errorInstructor.status }}</strong></small>
              </span>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col col-sm-12">
            <hr>
          </div>

          <div class="col col-sm-6">
            <div class="form-group form-row">
              <div class="col col-sm-2 col-form-label font-weight-bolder text-right">
                CREATED BY:
              </div>
              <div class="col col-sm-10">
                <input
                  type="text"
                  class="form-control form-control-xs"
                  placeholder="SYSTEM GENERATED"
                  disabled
                  :value="instructor.createdBy"
                >
              </div>
            </div>

            <div class="form-group form-row">
              <div class="col col-sm-2 col-form-label font-weight-bolder text-right">
                CREATED AT:
              </div>
              <div class="col col-sm-10">
                <input
                  type="text"
                  class="form-control form-control-xs"
                  placeholder="SYSTEM GENERATED"
                  disabled
                  :value="instructor.createdAt"
                >
              </div>
            </div>
          </div>

          <div class="col col-sm-6">
            <div class="form-group form-row">
              <div class="col col-sm-3 col-form-label font-weight-bolder text-right">
                LAST UPDATED BY:
              </div>
              <div class="col col-sm-9">
                <input
                  type="text"
                  class="form-control form-control-xs"
                  placeholder="SYSTEM GENERATED"
                  disabled
                  :value="instructor.updatedBy"
                >
              </div>
            </div>

            <div class="form-group form-row">
              <div class="col col-sm-3 col-form-label font-weight-bolder text-right">
                LAST UPDATED AT:
              </div>
              <div class="col col-sm-9">
                <input
                  type="text"
                  class="form-control form-control-xs"
                  placeholder="SYSTEM GENERATED"
                  disabled
                  :value="instructor.updatedAt"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import { formMixins } from "@/mixins/formMixins";

export default {
  mixins: [formMixins],
  name: "ViewInstructor",
  data() {
    return {
      instructorEditable: false,
      instructorData: {}
    }
  },

  methods: {
    ...mapActions([ 'clearInstructorData', 'getInstructor', 'getTrainingCenters', 'updateInstructor' ]),

    async editInstructor() {

      if(this.instructorEditable) {
        if(await this.confirmUpdateAlert('Are you sure you want to update this instructor')) {
          if(await this.checkPassword()) {
            let result = await this.updateInstructor(this.instructorData);
            if(result) {
              this.successAlert('Training Course Successfully Updated', 'UPDATE');
              this.cancelEdit();
            } else {
              this.errorAlert(this.generateErrorMessage(this.errorInstructor), 'UPDATE RECORD')
            }
          } else {
            this.errorAlert(this.generateErrorMessage(this.errorInstructor), 'UPDATE RECORD')
          }
        }
      } else {
        this.instructorEditable = true;
      }

      },

    cancelEdit() {
      this.instructorData = {};
      this.instructorData = Object.assign({}, this.instructor);
      this.instructorEditable = false;
    },

    async checkPassword() {
      let matched = true;
      if(this.instructorData.password) {
        if(this.instructorData.password !== this.instructorData.confirmPassword) {
          this.errorInstructor.password = 'PASSWORD NOT MATCHED';
          matched = false;
        }
      } else {
        delete this.instructorData['password'];
      }
      return matched;
      },

    async initializeData() {
      await this.getInstructor(this.$route.params.id);
      this.instructorData = Object.assign({}, this.instructor);
    }

    },

  computed: {
    ...mapGetters([ 'errorInstructor', 'instructor', 'trainingCenters' ]),
    createdBy() {
      if(this.instructor.created_by) {
        let instructor = this.instructor.created_by;
        return `${instructor.name} ${instructor.middle_name.charAt(0)}. ${instructor.last_name}`;
      }
      return '';
      },
    updatedBy() {
      if(this.instructor.updated_by) {
        let instructor = this.instructor.updated_by;
        return `${instructor.name} ${instructor.middle_name.charAt(0)}. ${instructor.last_name}`;
      }
      return '';
      },
  },

  created() {
    this.initializeData();
    if(!this.trainingCenters.length)
      this.getTrainingCenters();
    },

  beforeDestroy() {
    this.clearInstructorData();
  }
}
</script>

<style scoped>

</style>
